export default __webpack_public_path__ + "static/media/EXLA.b542db9c.png";